export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";
export const CREATE_ORDER_RESET = "CREATE_ORDER_RESET";

export const GET_SINGLE_ORDER_REQUEST = "GET_SINGLE_ORDER_REQUEST";
export const GET_SINGLE_ORDER_SUCCESS = "GET_SINGLE_ORDER_SUCCESS";
export const GET_SINGLE_ORDER_FAIL = "GET_SINGLE_ORDER_FAIL";

export const GET_USER_ALL_ORDER_REQUEST = "GET_USER_ALL_ORDER_REQUEST";
export const GET_USER_ALL_ORDER_SUCCESS = "GET_USER_ALL_ORDER_SUCCESS";
export const GET_USER_ALL_ORDER_FAIL = "GET_USER_ALL_ORDER_FAIL";
